import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import CustomSelect from '../../common/formElements/CustomSelect';
import ParentDocCard from '../common/ParentDocCard';
import ParentContentCard from '../common/ParentContentCard';
import { validateName } from '../../common/utils/validate';
import DocsLink from '../../common/custom/DocsLink';
import WebHookHeaderNav from './WebHookHeaderNav';
import { REST_API } from 'drapcode-constant';
export class CreateWebhook extends Component {
  static propTypes = {
    webhook: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    name: '',
    nameError: '',
    type: REST_API,
    typeError: '',
  };

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    if (name === 'name') {
      const validateMsg = validateName(value);
      if (validateMsg) {
        return this.setState({ nameError: validateMsg });
      }
      this.setState({ [name]: value, nameError: '' });
    } else if (name === 'type') {
      this.setState({ [name]: value, typeError: '' });
    }
  };

  handleSubmit = async () => {
    const { name, type } = this.state;
    const { projectId, version } = this.props.match.params;
    this.props.actions
      .createWebhook({ projectId, name, type, version })
      .then((data) => {
        this.props.history.push(`/webhook/${version}/v/${projectId}/edit/${data.uuid}`);
      })
      .catch((err) => console.log('err', err));
  };

  showCreateForm = () => {
    const { nameError, typeError, name, type } = this.state;
    return (
      <div className="row mx-auto">
        <ParentContentCard title="Webhook" icon="webhook">
          <div className="form-horizontal">
            <div className="row mx-auto">
              <div className="col-md-5 col-lg-5 col-sm-4 col-xs-12">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Method Name">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <input
                      type="text"
                      name="name"
                      value={name}
                      className="form-control form-control-sm"
                      placeholder="Name of Webhook"
                      onChange={this.handleChange}
                    />
                    {nameError && <p className="error">{nameError}</p>}
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-5 col-sm-4 col-xs-12">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Method Name">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('select')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <select
                      name="type"
                      value={type}
                      className="form-control form-control-sm custom-select-sm"
                      onChange={this.handleChange}
                    >
                      <option value="">Select Type</option>
                      <option value={REST_API}>REST_API</option>
                    </select>
                    {typeError && <p className="error">{typeError}</p>}
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-lg-2 col-sm-4 col-xs-12 text-right">
                <button className="btn btn-theme-submit" type="button" onClick={this.handleSubmit}>
                  <i className={`wb ${drapcodeIcon('save')}`}></i>
                  &nbsp;Create Webhook&nbsp;
                </button>
              </div>
            </div>
          </div>
        </ParentContentCard>
        <ParentDocCard>
          <h5>
            <b> Webhook</b>
          </h5>
          <p>
            Webhooks allows you to send your data on DrapCode’s API and then save it to your web
            app’s database on DrapCode after collection mapping. You can create a webhook using REST
            API.
          </p>
          <br />
        </ParentDocCard>
      </div>
    );
  };

  render() {
    const { projectId, version } = this.props.match.params;
    return (
      <div className="main">
        <div className="section">
          <WebHookHeaderNav
            version={version}
            activeTab={REST_API}
            projectId={projectId}
            title="Webhook"
            icon="webhook"
          />
          <div className="container">{this.showCreateForm()}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    webhook: state.webhook,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateWebhook);
